import React from "react";
import { motion } from "framer-motion";

export const easeLux = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: easeLux }}
    className={className}
  >
    {children}
  </motion.div>
);

// Masked line-by-line text reveal for hero headings
export const RevealLines = ({ lines, className = "", lineClassName = "", startDelay = 0.2 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="hero-line-mask">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, delay: startDelay + i * 0.14, ease: easeLux }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09 } },
};

export const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: easeLux } },
};
